import React from 'react'

import { Grid } from '../structure/Grid'
import { useSelectableColors } from '../theme/_hooks/colors'
import Circle from '../shapes/Circle'
import Icon from '../shapes/Icon'

const ColorPicker = ({ value, onChange, options }) => {
  const colors = useSelectableColors()

  return (
    <Grid align="center" gap={0.4} wrap>
      {colors.map(color => {
        const selected = color === value
        return (
          <Circle
            color={color}
            key={color}
            borderWidth={0.2}
            borderColor={selected && 'light4'}
            onClick={() => onChange(value === color ? null : color)}
          >
            {selected && <Icon name="BsCheck" color="white" size={1.4} />}
          </Circle>
        )
      })}
    </Grid>
  )
}

export default ColorPicker
